(() => {
  if (customElements.get('ribao-welcome-offer')) return;
  customElements.define('ribao-welcome-offer', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('.ribao-offer__launcher');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const preview = this.dataset.editor === 'true' || (this.dataset.previewAllowed === 'true' && new URLSearchParams(location.search).get('ribao_offer_preview') === '1');
      this.preview = preview;
      this.dismissKey = 'ribao_welcome_offer_v1_dismissed_until';
      this.sessionKey = 'ribao_welcome_offer_v1_shown';
      this.launcher.hidden = false;
      this.launcher.addEventListener('click', () => this.open(), options);
      this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        const box = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.rememberDismissal(); this.restoreScroll(); this.launcher.hidden = false;
        if (this.previousFocus?.isConnected && this.previousFocus !== document.body) this.previousFocus.focus({ preventScroll: true });
        else this.launcher.focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-offer-login]').addEventListener('click', () => this.rememberDismissal(), options);
      if (!preview && this.wasSeen()) return;
      this.timer = setTimeout(() => this.tryOpen(), preview ? 600 : Math.max(3000, Number(this.dataset.delay) || 8000));
    }
    wasSeen() {
      try { return Number(localStorage.getItem(this.dismissKey)) > Date.now() || sessionStorage.getItem(this.sessionKey) === '1'; }
      catch (_) { return false; }
    }
    rememberDismissal() {
      if (this.preview) return;
      try {
        localStorage.setItem(this.dismissKey, String(Date.now() + (Number(this.dataset.dismissDays) || 7) * 86400000));
        sessionStorage.setItem(this.sessionKey, '1');
      } catch (_) { /* Browsing stays usable when storage is unavailable. */ }
    }
    tryOpen() {
      if (!this.isConnected || this.dialog.open) return;
      const active = document.activeElement;
      const busy = document.hidden || active?.matches('input, textarea, select, [contenteditable="true"]') || Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .modal.show, .modal.in, #cart-mobile.is-open, #cart-mobile.open')).some(element => element !== this.dialog && element.getClientRects().length > 0);
      if (busy) { this.timer = setTimeout(() => this.tryOpen(), 3000); return; }
      if (!this.preview && this.wasSeen()) return;
      this.open();
    }
    open() {
      if (this.dialog.open) return;
      clearTimeout(this.timer);
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.scrollLocked = true; this.launcher.hidden = true;
      if (!this.preview) { try { sessionStorage.setItem(this.sessionKey, '1'); } catch (_) {} }
    }
    restoreScroll() {
      if (this.scrollLocked) document.documentElement.style.overflow = this.previousOverflow;
      this.scrollLocked = false;
    }
    disconnectedCallback() {
      clearTimeout(this.timer); this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
    }
  });
})();
